var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "86px",
    viewBox: "0 0 84 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.08347436%",
    y1: "104.897426%",
    x2: "112.70225%",
    y2: "-9.15975721%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2222",
    offset: "32.9878827%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#720096",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Docs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Docs_LandingPage_Design_DarkMode",
    transform: "translate(-533.000000, -2477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(47.000000, 2407.452708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(486.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github",
    transform: "translate(20.500000, 23.608724)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84249474,-1.71337056 C3.40967075,-1.72678862 3.9658578,-1.69854024 4.51392249,-1.61830272 C6.76216783,-1.28915611 8.89057213,-0.0826886027 11.2929767,1.37515684 C11.9864984,1.8048793 12.3864724,2.34733888 13.0996035,2.15563694 C15.8645683,1.40601889 18.6575898,1.00917433 21.400293,0.972609411 C24.203273,1.00820328 26.9964457,1.40590051 29.7629176,2.15584749 C30.3969643,2.32694995 30.7572294,1.87626084 31.2017697,1.60044696 C34.0025567,-0.102245667 36.1170065,-1.29275909 38.3485363,-1.61844713 C38.8945692,-1.69813971 39.4486837,-1.72620887 40.0203192,-1.71066693 C40.3894499,-1.09211028 40.6646815,-0.532609402 40.8075472,-0.104948578 C41.332606,1.46678649 41.4991104,5.53632956 40.6615294,8.06835195 C40.5806261,8.30648321 40.7243431,8.49890032 40.8230677,8.61492844 C42.7116702,10.8531988 43.9578775,13.7419877 44.4462024,16.7927872 C44.9303582,19.8175403 44.6685098,22.9914562 43.6026551,25.8159194 C42.6810864,28.2597129 40.9461222,31.0821087 37.6709529,33.3508377 C35.3023903,34.991555 32.0998133,36.3565978 27.7409974,37.0068019 C27.979453,37.4960476 28.245388,37.8395405 28.4914123,38.1597869 C29.6912626,39.7216156 30.5802238,40.8911742 30.5748701,44.2278021 L30.5748701,44.2278021 L30.5748701,53.3833094 C30.5770847,53.7431779 30.6193485,54.0975516 30.6980525,54.4397822 L30.6980525,54.4397822 L31.212728,56.6777577 L28.9647156,57.1466556 C26.4994414,57.6608708 23.9768103,57.9246322 21.4302867,57.9246322 C18.8837823,57.9246322 16.3602153,57.6608668 13.89496,57.1466556 L13.89496,57.1466556 L11.6466436,56.6776943 L12.1616912,54.4394858 C12.2412789,54.0936267 12.2843808,53.7355879 12.2866007,53.3708097 L12.2866007,53.3708097 L12.2866036,44.2278287 C12.2812462,40.8950681 13.1672329,39.7271863 14.3677429,38.1626964 C14.6139878,37.8417931 14.8803124,37.497358 15.1532655,37.0805536 C10.7616177,36.3570601 7.55913879,34.9918564 5.19055396,33.3510773 C1.91538857,31.0822869 0.180204857,28.2600452 -0.742027835,25.8160624 C-1.80750249,22.9912436 -2.06908769,19.8177268 -1.5849731,16.7932313 C-1.0966931,13.7427123 0.149150334,10.8540387 2.04370411,8.60761393 C2.13283886,8.50288492 2.28461393,8.31804499 2.21209302,8.1046984 C1.3615896,5.53620439 1.52897946,1.46752855 2.05377584,-0.104505917 C2.19679438,-0.53291985 2.47241969,-1.09362521 2.84249474,-1.71337056 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 5,
    cx: 42,
    cy: 42,
    r: 39.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4251309,66.6644534 C30.3753676,67.7308109 27.906466,67.0276121 26.2303485,64.2032578 C24.2700616,60.9059303 20.9486517,58.2462977 17.1417458,58.5747781 C15.784476,58.6922991 14.7797687,59.8877369 14.8972897,61.2440434 C15.0138472,62.6013135 16.2131381,63.6079472 17.5665548,63.489463 C19.3293682,63.3363005 21.0680992,65.1723235 21.9899637,66.7222505 C24.625514,71.163962 28.8947972,72.7495305 33.3480681,71.7968408 C33.5246705,67.0927946 33.5503582,65.3819988 33.4251309,66.6644534 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubDarkMode);
export default __webpack_public_path__ + "static/media/github-dark-mode.9039a4dd18a029c35d7d73ec70ea02e6.svg";
export { ForwardRef as ReactComponent };